export const getAudioDevices = (selectedDevices: {
  selectedAudioInputDeviceId: string;
  selectedAudioOutputDeviceId: string;
  selectedRingingOutputDeviceId: string;
}) =>
  new Promise<{
    audioInputDevices: MediaDeviceInfo[];
    audioOutputDevices: MediaDeviceInfo[];
    selectedAudioInputDevice?: MediaDeviceInfo;
    selectedAudioOutputDevice?: MediaDeviceInfo;
    selectedRingingOutputDevice?: MediaDeviceInfo;
  }>((resolve, reject) => {
    const {
      selectedAudioInputDeviceId,
      selectedAudioOutputDeviceId,
      selectedRingingOutputDeviceId,
    } = selectedDevices;

    navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        const audioInputDevices = devices.filter(
          (x) => x.kind === 'audioinput',
        );
        const audioOutputDevices = devices.filter(
          (x) => x.kind === 'audiooutput',
        );

        const defaultInputDevice = audioInputDevices.find(
          (x) => x.deviceId === 'default',
        );
        const defaultOutputDevice = audioOutputDevices.find(
          (x) => x.deviceId === 'default',
        );

        const selectedAudioInputDevice =
          audioInputDevices.find(
            (x) => x.deviceId === selectedAudioInputDeviceId,
          ) || defaultInputDevice;
        const selectedAudioOutputDevice =
          audioOutputDevices.find(
            (x) => x.deviceId === selectedAudioOutputDeviceId,
          ) || defaultOutputDevice;
        const selectedRingingOutputDevice =
          audioOutputDevices.find(
            (x) => x.deviceId === selectedRingingOutputDeviceId,
          ) || defaultOutputDevice;

        resolve({
          audioInputDevices,
          audioOutputDevices,
          selectedAudioInputDevice,
          selectedAudioOutputDevice,
          selectedRingingOutputDevice,
        });
      })
      .catch(reject);
  });

export const testCanChangeAudioDevice = () => {
  const mockAudioEl = new Audio();

  if (typeof mockAudioEl.setSinkId !== 'function') {
    return false;
  }
  if (!('sinkId' in HTMLMediaElement.prototype)) {
    return false;
  }

  if (typeof navigator.mediaDevices.enumerateDevices !== 'function') {
    return false;
  }

  return true;
};
